<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next';
import { computed } from 'vue';
import { Button } from '@/components/ui/button';
import { useAppearance } from '@/composables/useAppearance';
import { useTranslations } from '@/composables/useTranslations';

const { resolvedAppearance, updateAppearance } = useAppearance();
const { t } = useTranslations();

const isLight = computed(() => resolvedAppearance.value === 'light');

const switchHint = computed(() =>
    isLight.value
        ? t('tools.footer.switch_to_dark', 'Switch to dark mode')
        : t('tools.footer.switch_to_light', 'Switch to light mode'),
);

function toggleTheme() {
    updateAppearance(isLight.value ? 'dark' : 'light');
}
</script>

<template>
    <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        class="shrink-0 rounded-md"
        :title="switchHint"
        :aria-label="switchHint"
        :aria-pressed="!isLight"
        @click="toggleTheme"
    >
        <Moon v-if="isLight" class="size-4" aria-hidden="true" />
        <Sun v-else class="size-4" aria-hidden="true" />
    </Button>
</template>
